import { render } from "./ValidateUser.vue?vue&type=template&id=0cc77128&scoped=true"
import script from "./ValidateUser.vue?vue&type=script&lang=js"
export * from "./ValidateUser.vue?vue&type=script&lang=js"

import "./ValidateUser.vue?vue&type=style&index=0&id=0cc77128&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc77128"]])

export default __exports__